import { Button, Form, Input, InputNumber, Typography } from 'antd';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const { Title } = Typography;

export const PrimaryButton = styled(Button)`
  background: #231f55;
`;
export const FormItemStyled = styled(Form.Item)<{ width?: string }>`
  width: ${(p) => (p.width ? p.width : 'auto')};
  max-width: 100%;
`;

export const FormItemInputStyled = styled(Input)`
  max-width: 350px;
`;

export const FormItemInputNumberStyled = styled(InputNumber)`
  max-width: 350px;
`;

export const FormContainer = styled.div`
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  height: auto;
  min-height: 400px;
  margin-right: 50px;
  position: relative;
  max-width: 1000px;
`;

export const FormFooterContainer = styled.div`
  margin-top: 20px;
  margin-right: 50px;
  margin-bottom: 50px;
  max-width: 1000px;
`;

export const NavigationButton = styled(Button)<{ isactive: 'true' | 'false' }>`
  width: 315px;
  color: ${(props) => (props.isactive === 'true' ? 'white' : '#64738b')} !important;
  background: ${(props) => (props.isactive === 'true' ? '#231f55' : 'transparent')} !important;
  border: 1px solid ${(props) => (props.isactive === 'true' ? 'transparent' : '#dfdfdf')} !important;
  text-align: left;
  box-shadow: 0px 7px 10px grey;
  font-weight: 900 !important;
  height: 50px !important;

  .fa-lg {
    margin-right: 10px;
  }
`;

export const StyledLinkButton = styled(Button)`
  color: white !important;
  background: #231f55 !important;
  border-radius: 15px;
`;

export const PageTitle = styled(Title)`
  color: #fff !important;
  position: relative;
`;

export const StyledIcon = styled(FontAwesomeIcon)`
  margin-right: 10px;
`;
